export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'Container',
              name: "Container Videos", 
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsSideVideo', 
                },
                
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};